import { type FC, type ReactNode } from 'react';
import classnames from 'classnames';

import { ModalContainer } from 'dibs-elements/exports/ModalContainer.tsx';
import { Link } from 'dibs-elements/exports/Link.tsx';
import Close from 'dibs-icons/exports/Close.ts';

import dibsCss from 'dibs-css';
import styles from './MobileNotificationsModal.module.css';

const MobileNotificationsModal: FC<{
    children: ReactNode;
    onClose: () => void;
    isMwDesignIterationVariant?: boolean;
}> = ({ children, onClose, isMwDesignIterationVariant = false }) => {
    return (
        <ModalContainer
            isOpen
            onClose={onClose}
            dataTn="notifications-modal-mobile"
            enableHistoryNavigation={isMwDesignIterationVariant}
        >
            <Link
                onClick={onClose}
                className={classnames(
                    dibsCss.absolute,
                    isMwDesignIterationVariant
                        ? [
                              dibsCss.topXsmall,
                              dibsCss.rightXxsmall,
                              dibsCss.wXlarge,
                              dibsCss.hXlarge,
                              dibsCss.inlineFlex,
                              dibsCss.itemsCenter,
                              dibsCss.justifyCenter,
                          ]
                        : [styles.closeButton, dibsCss.rightSmall]
                )}
                dataTn="notifications-modal-mobile-close-button"
            >
                <Close variation="24" />
            </Link>
            <div className={dibsCss.pbSmall}>{children}</div>
        </ModalContainer>
    );
};

export default MobileNotificationsModal;
